import WooCommerce from "@/services/wooservice.js";
import Store from "@/store";

const getPageProducts = (categoryId, page, per_page) => {
  return new Promise((resolve, reject) => {
    WooCommerce.get("products", {
      category: categoryId,
      page,
      per_page,
    })
      .then((res) => resolve(res.data))
      .catch((err) => reject(err));
  });
};

const getProductCount = async (categoryId) => {
  const categoryList = Store.getters["categories/categories"];
  let category;

  if (!categoryList.length) {
    category = await WooCommerce.get("products/categories/" + categoryId);
  } else {
    category = categoryList.find((cat) => cat.id === categoryId);
  }

  return category.data?.count || category.count || 0;
};

export const getProducts = async (params) => {
  if (!params?.categoryId?.length) {
    const allProducts = await WooCommerce.get("products", {
      page: 1,
      per_page: 99,
    });
    return allProducts.data;
  }

  const { categoryId, categoryProductCount, productsPerPage = 10 } = params;

  try {
    const per_page = productsPerPage;

    if (
      typeof categoryProductCount === "null" ||
      typeof categoryProductCount === "undefined"
    ) {
      categoryProductCount = await getProductCount(categoryId);
    }

    const totalPages = Math.ceil(categoryProductCount / per_page);
    const promises = [];

    for (let i = 0; i < totalPages; i++) {
      promises.push(getPageProducts(categoryId, i + 1, per_page));
    }

    const data = await Promise.all(promises);
    return data.flat(1);
  } catch (e) {
    throw e;
  }
};
